import React from 'react';

// Reusable ambient color background component - adds soft floating color blobs
// with breathing animation. Use inside a `relative` parent.
const ColorAmbient = ({
  variant = 'default',
  intensity = 'medium',
}) => {
  const opacityMap = {
    subtle: 0.06,
    medium: 0.09,
    strong: 0.14,
  };
  const op = opacityMap[intensity] || 0.09;

  const variants = {
    default: [
      { c: '0,183,199', top: '10%', left: '5%', size: 360, delay: '0s' },
      { c: '229,0,126', top: '65%', left: '85%', size: 320, delay: '1.5s' },
      { c: '255,215,0', top: '85%', left: '15%', size: 280, delay: '3s' },
      { c: '15,123,63', top: '25%', left: '75%', size: 280, delay: '2s' },
    ],
    cool: [
      { c: '0,183,199', top: '15%', left: '10%', size: 380, delay: '0s' },
      { c: '0,128,128', top: '70%', left: '80%', size: 340, delay: '2s' },
      { c: '0,61,165', top: '80%', left: '20%', size: 300, delay: '4s' },
    ],
    warm: [
      { c: '255,107,53', top: '15%', left: '85%', size: 360, delay: '0s' },
      { c: '255,215,0', top: '65%', left: '10%', size: 340, delay: '1.5s' },
      { c: '229,0,126', top: '85%', left: '75%', size: 300, delay: '3s' },
    ],
    rainbow: [
      { c: '0,183,199', top: '5%', left: '5%', size: 300, delay: '0s' },
      { c: '229,0,126', top: '20%', left: '85%', size: 300, delay: '1s' },
      { c: '255,215,0', top: '55%', left: '15%', size: 300, delay: '2s' },
      { c: '15,123,63', top: '55%', left: '85%', size: 300, delay: '3s' },
      { c: '255,107,53', top: '90%', left: '50%', size: 300, delay: '4s' },
    ],
  };

  const blobs = variants[variant] || variants.default;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {blobs.map((b) => (
        <div
          key={`${b.c}-${b.top}-${b.left}`}
          className="absolute rounded-full blur-3xl animate-breathe"
          style={{
            backgroundColor: `rgba(${b.c}, ${op})`,
            top: b.top,
            left: b.left,
            width: `${b.size}px`,
            height: `${b.size}px`,
            transform: 'translate(-50%, -50%)',
            animationDelay: b.delay,
          }}
        />
      ))}
    </div>
  );
};

export default ColorAmbient;
